// extracted by mini-css-extract-plugin
export default {"card":"style_card__s-vkL","text":"style_text__CTN12","button":"style_button__AyoRI"};